import { render, staticRenderFns } from "./BookSnippet.vue?vue&type=template&id=bd35910a&scoped=true&"
import script from "./BookSnippet.vue?vue&type=script&lang=js&"
export * from "./BookSnippet.vue?vue&type=script&lang=js&"
import style0 from "./BookSnippet.vue?vue&type=style&index=0&id=bd35910a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd35910a",
  null
  
)

export default component.exports